/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Gym_LeadInputs */

const en_features_gym_lead = /** @type {(inputs: Features_Gym_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A plan for your gym.`)
};

const pl_features_gym_lead = /** @type {(inputs: Features_Gym_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan pod Twoją siłownię.`)
};

/**
* | output |
* | --- |
* | "A plan for your gym." |
*
* @param {Features_Gym_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_gym_lead = /** @type {((inputs?: Features_Gym_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Gym_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_gym_lead(inputs)
	return en_features_gym_lead(inputs)
});